import execute_on from "../../libs/execute-on";

execute_on('survey.summary.edit', function ($page) {
    function copyLink() {
        const pollsterUrl = document.getElementById('pollsterUrl').innerText;
        const pollsterSlug = document.getElementById('pollsterSlug').innerText;
        navigator.clipboard.writeText([pollsterUrl, pollsterSlug].join('/'));

    }

    function setSlugInsideSecureLinkButton() {
        const pollsterSlug = document.getElementById('pollsterSlug').innerText;
        $('#ready-to-go-link, #go-live-link, #update-slug-link').trigger('overwrite-additional-data', [{'slug': pollsterSlug}]);
    }

    $page
        .on('click', '.copy-link', copyLink)
        .on('blur keyup paste input', '#pollsterSlug', setSlugInsideSecureLinkButton)
    ;
})
